import { Modal, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

export const ConfirmPlatformRemovalModal = ({
  isOpen,
  closeModal,
  onConfirm,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => Promise<void>;
}) => {
  const intl = useIntl();

  const onConfirmRemove = async () => {
    await onConfirm();
    closeModal();
  };

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: platform removal modal title",
        defaultMessage: "Are you sure you want to remove this platform?",
      })}
      primaryAction={{
        onAction: onConfirmRemove,
        content: intl.formatMessage({
          id: "funding-application: confirm removal label",
          defaultMessage: "Yes, remove this",
        }),
      }}
      tertiaryAction={{
        onAction: closeModal,
        content: intl.formatMessage({
          id: "funding-application: reject removal label",
          defaultMessage: "No, keep this",
        }),
      }}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <Text>
        {intl.formatMessage({
          id: "funding-application: platform removal confirmation text",
          defaultMessage:
            "Removing this platform may delay your application. If you can add this platform, please connect it now. Alternatively, you can remove it, but we may ask you to connect it later if needed.",
        })}
      </Text>
    </Modal>
  );
};
